'use strict';

angular.module('docketbook').
  controller('navController', function (userService, $scope, $state, $location, $window, $stateParams, accessControl, $rootScope, $timeout) {
    $scope.myDocketbook = false;
    if ($stateParams.myDocketbook == true) {
      $scope.myDocketbook = true;
    }

    $scope.currentState = $state.current;
    $scope.mobileNav = false;
    $scope.currentOrg = accessControl.currentOrg();
    $scope.sampleCompany = accessControl.isSampleCompany();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.navOption = $state.current.data.subnavOption;
    $scope.currentUser = accessControl.currentUser();
    $scope.userCanDoAction = userService.userCanDoAction;
    $scope.organisations = accessControl.allowedOrganisations();

    $rootScope.$on('OrganisationsListRefreshed', function () {
      $scope.organisations = accessControl.allowedOrganisations();
    });

    if ($scope.currentOrg && $scope.currentOrg.accessAllowed == false) {
      if ($scope.currentState && $scope.currentState.name != 'main.groupDashboard' && $scope.currentState.name != 'companySettings.billing') {
        $state.go('main.groupDashboard', { orgId: $scope.currentOrg.id });
      }
    }

    $rootScope.$on('ScopeUpdated', function () {
      $scope.currentOrg = accessControl.currentOrg();
      $scope.currentOrgGroup = accessControl.currentOrgGroup();
    });

    if ($state.current.data.mainnavOption == 'companySettings') {
      $(".leftNavOuter").addClass('companySettingsHeight');
    }

    $scope.canViewOrgSettings =
      $scope.currentOrg.globalAdministrators.includes($scope.currentUser.id)
      || $scope.userHasPermission('io.docketbook.uoapi.viewOrganisationSettings')

    /* F/E Permission Checking */
    $scope.userHasPermission = function (permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    $scope.openIntercom = function () {
      window.FreshworksWidget('open', 'ticketForm')
    }

    $scope.toggleMobileNav = function () {
      $scope.mobileNav = !$scope.mobileNav;
    }

    $scope.goTo = function (view) {
      var currentPath = $location.path();
      if (currentPath == "/" + view) {
        $scope.mobileNav = false;
      }
      $location.path(view);
    }

    $scope.goToDirect = function (href) {
      $window.location.href = href;
    }

    /*** ORG SCOPE FUNCTIONS - FOR MOBILE ****/
    $scope.openScopeDropdown = function () {
      if ($(".orgScopeDropdown").css('display') == 'none') {
        $(".orgScopeDropdown").slideDown();
        $(".orgScopeIcon").addClass('open');
      } else {
        $(".orgScopeDropdown").slideUp();
        $(".orgScopeIcon").removeClass('open');
        $("ul.inner").each(function (item) {
          if (!($(this).hasClass('open'))) {
            $(this).slideUp();
          }
        });
      }
    }

    $scope.openOrgUnits = function (orgId) {
      if ($("#org" + orgId + " ul.inner").css('display') == 'none') {
        $("#org" + orgId + " ul.inner").slideDown();
      } else {
        $("#org" + orgId + " ul.inner").slideUp();
      }
    }

    $scope.openUserDropdown = function () {
      if ($(".userDropdown").css('display') == 'none') {
        $(".userDropdown").slideDown();
        $(".currentUserControl").addClass('open');
      } else {
        $(".userDropdown").slideUp();
        $(".currentUserControl").removeClass('open');
      }
    }

    $scope.openHelpLink = function () {
      window.open("https://help.docketbook.com.au/hc/en-us/signin?return_to=https%3A%2F%2Fhelp.docketbook.com.au%2Fhc%2Fen-us&locale=en-us");
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/navigation.js